/**
 * @generated SignedSource<<79150a4d9c6e9dbfd912885097bc3776>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GwtUserFilterDropdown$data = {
  readonly companies: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: UUID;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "GwtUserFilterDropdown";
};
export type GwtUserFilterDropdown$key = {
  readonly " $data"?: GwtUserFilterDropdown$data;
  readonly " $fragmentSpreads": FragmentRefs<"GwtUserFilterDropdown">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GwtUserFilterDropdown",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "NAME_ASC"
        }
      ],
      "concreteType": "CompaniesConnection",
      "kind": "LinkedField",
      "name": "companies",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Company",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "companies(orderBy:\"NAME_ASC\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1b69c28370a3f352cdc2f39ca5ac5fc9";

export default node;
